import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'
import { COLORS } from '../data/enums'

export default function FaceFeature({
  scaleX,
  scale,
  gradient,
  pupil,
  rotation = 0,
  spacing = 0,
  verticalOffset,
  outline,
  showEyeLiner,
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftPupilTransformOrigin = '17.22 13.82'
  const rightPupilTransformOrigin = '42.22 13.82'
  return (
    <>
      <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
        {/* LEFT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${-spacing})`} transform-origin={leftPupilTransformOrigin}>
          <g transform={`rotate(${rotation})`} transform-origin="inherit">
            <path
              className="cls-2"
              d="M17.9,7.42c-6.87-.59-11.18,5.92-11.18,5.92,0,0,3.47,8.17,11.18,8.04,3.77-.06,6.82-3.13,6.82-6.99s-3.07-6.65-6.82-6.98Z"
              fill={COLORS.WHITE}
            />
            <path
              className="cls-3"
              d="M17.73,21.88c-7.83,0-11.43-8.26-11.46-8.35l-.1-.25,.15-.22c.18-.28,4.54-6.75,11.64-6.14h0c4.22,.37,7.28,3.51,7.28,7.47s-3.21,7.42-7.31,7.49c-.06,0-.12,0-.18,0ZM7.3,13.39c.65,1.33,4,7.49,10.43,7.49,.05,0,.11,0,.16,0,3.55-.06,6.33-2.91,6.33-6.49s-2.68-6.16-6.37-6.48c-5.77-.49-9.73,4.36-10.56,5.48Z"
              fill={outline}
            />
          </g>
          <path
            className="cls-1"
            d="M17.22,19.3c3.04,0,5.5-2.46,5.5-5.5s-2.46-5.5-5.5-5.5-5.5,2.46-5.5,5.5,2.46,5.5,5.5,5.5Z"
            fill={`url(#${randomGradientId1})`}
          />
          <g transform={`rotate(${rotation})`} transform-origin="inherit">
            <path
              className="cls-4"
              d="M17.22,16.57c1.52,0,2.75-1.23,2.75-2.75s-1.23-2.75-2.75-2.75-2.75,1.23-2.75,2.75,1.23,2.75,2.75,2.75Z"
              fill={pupil}
            />
            {showEyeLiner && (
              <path d="M25.22,14.39c-1.26-6.41-9.22-7.46-14.08-4.57-1.76,.9-3.41,2.1-4.98,3.46,1.02-1.83,2.51-3.42,4.28-4.63,2.64-1.87,6.29-2.73,9.47-1.68,3.11,.93,5.94,4.12,5.32,7.42h0Z" />
            )}
          </g>
          <path
            className="cls-2"
            d="M19.06,12.88c.51,0,.92-.41,.92-.92s-.41-.92-.92-.92-.92,.41-.92,.92,.41,.92,.92,.92Z"
            fill={COLORS.WHITE}
          />
        </g>
        {/* RIGHT EYE */}
        <g transform={`scale(${scale},${scale}) translate(${spacing})`} transform-origin={rightPupilTransformOrigin}>
          <g transform={`rotate(${-rotation})`} transform-origin="inherit">
            <path
              className="cls-2"
              d="M41.55,7.42c6.87-.59,11.18,5.92,11.18,5.92,0,0-3.47,8.17-11.18,8.04-3.77-.06-6.82-3.13-6.82-6.99s3.07-6.65,6.82-6.98Z"
              fill={COLORS.WHITE}
            />
            <path
              className="cls-3"
              d="M41.72,21.88c-.06,0-.12,0-.18,0-4.1-.07-7.31-3.36-7.31-7.49s3.06-7.11,7.28-7.47h0c7.1-.61,11.46,5.87,11.64,6.14l.15,.22-.1,.25c-.04,.08-3.64,8.35-11.46,8.35Zm-.13-13.96h0c-3.69,.32-6.37,3.04-6.37,6.48s2.78,6.43,6.33,6.49c.06,0,.11,0,.17,0,6.42,0,9.78-6.16,10.43-7.49-.82-1.11-4.77-5.97-10.56-5.48Z"
              fill={outline}
            />
          </g>
          <path
            className="cls-5"
            d="M42.22,19.3c3.04,0,5.5-2.46,5.5-5.5s-2.46-5.5-5.5-5.5-5.5,2.46-5.5,5.5,2.46,5.5,5.5,5.5Z"
            fill={`url(#${randomGradientId2})`}
          />
          <g transform={`rotate(${-rotation})`} transform-origin="inherit">
            <path
              className="cls-4"
              d="M42.22,16.57c1.52,0,2.75-1.23,2.75-2.75s-1.23-2.75-2.75-2.75-2.75,1.23-2.75,2.75,1.23,2.75,2.75,2.75Z"
              fill={pupil}
            />
            {showEyeLiner && (
              <path d="M53.29,13.28c-2.91-2.67-6.52-4.96-10.49-5.05-3.83-.05-7.68,2.14-8.57,6.16-.94-4.66,4.34-8.3,8.64-7.85,4.39,.27,8.22,3.13,10.43,6.74h0Z" />
            )}
          </g>
          <path
            className="cls-2"
            d="M44.06,12.88c.51,0,.92-.41,.92-.92s-.41-.92-.92-.92-.92,.41-.92,.92,.41,.92,.92,.92Z"
            fill={COLORS.WHITE}
          />
        </g>
      </g>

      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="17.22"
          y1="178.47"
          x2="17.22"
          y2="189.81"
          gradientTransform="translate(0 198) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          x1="42.22"
          x2="42.22"
          y1="178.47"
          y2="189.81"
          gradientTransform="translate(0 198) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".27" stopColor={gradient[1]} />
          <stop offset="1" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </>
  )
}
